import { render, staticRenderFns } from "./MultiCategorySubmissionsReviewTableRow.vue?vue&type=template&id=ed096b5a&scoped=true&"
import script from "./MultiCategorySubmissionsReviewTableRow.vue?vue&type=script&lang=js&"
export * from "./MultiCategorySubmissionsReviewTableRow.vue?vue&type=script&lang=js&"
import style0 from "./MultiCategorySubmissionsReviewTableRow.vue?vue&type=style&index=0&id=ed096b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed096b5a",
  null
  
)

export default component.exports